import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import { Typography } from 'antd'

class EditText extends Component {
    static propTypes = {
        initialParams: PropTypes.object,
        onSave: PropTypes.func.isRequired,
        resetOnSave: PropTypes.bool,
        value: PropTypes.string,
    }

    static defaultProps = {
        initialParams: {},
        resetOnSave: false,
        value: ''
    }

    constructor (props) {
        super(props)

        this.state = {
            strValue: _.toString(props.value)
        }
    }

    componentDidUpdate (prevProps) {
        if (prevProps.value !== this.props.value && this.props.value !== this.state.strValue) {
            this.setState({ strValue: _.toString(this.props.value) })
        }
    }

    onChange = strValue => {
        const { initialParams, onSave, resetOnSave, value } = this.props

        onSave({ ...initialParams, value: strValue })
        // With resetOnSave the cell keeps showing the last confirmed value —
        // the save's refetch/normalization pushes the accepted value back in
        // through props, so a rejected edit never sticks on screen.
        this.setState({ strValue: _.toString(resetOnSave ? value : strValue) })
    }

    render () {
        return <Typography.Text editable={{ onChange: this.onChange }}>{this.state.strValue}</Typography.Text>
    }
}

export default EditText
